import { v4 as uuid } from 'uuid'
import { getFullDate } from '@/helpers/date.helpers'
import { ChatModel } from '@/models/chat.model'
import { GroupModel } from '@/models/group.model'
import { SelectedDepartmentModel } from '@/models/department.model'
import { Campaign } from '@/models/campaign.model'

type BuildNewChat = {
  group: GroupModel
  groupImageUrl: string
  ownerId: string
  department: SelectedDepartmentModel
  campaign: Campaign
}

export async function buildNewChat({
  campaign,
  group,
  ownerId,
  department,
  groupImageUrl
}: BuildNewChat): Promise<Partial<ChatModel>> {
  const baseDate = new Date()
  const dateNow = baseDate.getTime()
  const dateMonth = baseDate.getMonth()
  return {
    id: uuid(),
    department: { id: department?.id, name: department?.name, color: department?.color },
    departmentId: department?.id,
    ...(groupImageUrl && { requesterPhoto: groupImageUrl }),
    ownerId,
    campaignId: campaign.id,
    status: 'in_progress',
    unreadMessagesCount: 0,
    receiverNumber: campaign.phoneNumber,
    requesterNumber: group.phone,
    isGroup: true,
    chatName: group?.name || group?.subject,
    operatorsId: null,
    operators: null,
    startDate: null,
    endDate: null,
    month: dateMonth,
    year: baseDate.getFullYear(),
    fullDate: getFullDate(baseDate),
    isFinishedUra: false,
    duration: null,
    ticket: null,
    lastMessage: null,
    updatedAt: dateNow,
    createdAt: dateNow,
    durations: [],
    ...group
  }
}
